var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('select',{staticClass:"form-control",attrs:{"id":_vm.id,"name":_vm.name,"disabled":_vm.disabled,"required":_vm.required}})])
}
var staticRenderFns = []

export { render, staticRenderFns }